export const ENDPOINTS = {
  // Team endpoints
  TEAMS: {
    GET_TEAM_ROSTER_PLAYERS: (teamId, rosterId) =>
      `/teams/${teamId}/rosters/${rosterId}/players`,
    UPDATE_ROSTER_JERSEY_COLORS: (teamId, rosterId) =>
      `/teams/${teamId}/rosters/${rosterId}/jersey-colors`,
  },
  // Game endpoints
  GAMES: {
    GET_GAME_ROSTERS: (gameId) => `/games/${gameId}/rosters`,
    GET_GAME_TIMELINE: (gameId) => `/games/${gameId}/timeline`,
    GET_GAME_SCOREBOARD: (gameId) => `/games/${gameId}/scoreboard`,
    UPDATE_GAME_ROSTER_JERSEY: (gameId, gamePlayerRosterId) =>
      `/games/${gameId}/rosters/${gamePlayerRosterId}/jersey-color`,
    DELETE_GENERIC_GOAL: (gameId) => `/games/${gameId}/goals`,
    GET_GAME_SETTINGS: (gameId) => `/games/${gameId}/settings`,
    GET_GAME_SHOOTOUT: (gameId) => `/games/${gameId}/shootout`,
  },
  // Player endpoints
  PLAYERS: {
    GET_PLAYER_HIGHLIGHTS: (playerId) => `/players/${playerId}/highlights`,
  },
  // Highlight endpoints
  HIGHLIGHTS: {
    GET_HIGHLIGHT: (highlightId) => `/highlights/${highlightId}`,
  },
  // User endpoints
  USERS: {
    GET_MY_REGISTRATIONS: () => '/users/me/registrations',
    GET_MY_PENDING_INSTALLMENTS: () => '/users/me/installments/pending',
    GET_MY_PENDING_DEPOSITS: () => '/users/me/deposits/pending',
    GET_MY_BILLING: (billingId) => `/users/me/billing/${billingId}`,
    GET_ME_PLAYERS3: () => '/users/me/players3',
  },
}
